import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";

@Injectable()
export class IsActivateMenuGuard implements CanActivate {
    connectedUser : any;
    constructor() {
        this.connectedUser = !!JSON.parse(localStorage.getItem('enseigne')) ? JSON.parse(localStorage.getItem('enseigne')) : '';
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let menuCode = route.children[0]["data"]["code"];
        
        let userRoleCodes : string[] = this.connectedUser.fonctionnaliteAutorise.filter(role => role.Statut).map(role => role.Code);
        return userRoleCodes.some(code => code === menuCode);
    }

}